//import FormHelperText from '@material-ui/core/FormHelperText';
import { Checkbox, FormControl, FormControlLabel } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PermIdentity from '@material-ui/icons/PermIdentity';
import classNames from 'classnames';
import React, { Fragment } from 'react';
import { Helmet } from "react-helmet";
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Link } from 'react-router-dom';
import Background from '../../assets/images/user.png';
import { EditDistributorStaffApi, Permissions as FreshPermissions, ProfilePath, ProfilePhotoStaffApi } from '../../constants';
import { EditStaffHeaderTitle } from '../../StringConstants';
import theme from '../../theme';
import UserProfile from '../auth/UserProfile';
import AuthService from '../AuthService';
const styles = {
    root: {
        flexGrow: 1,
        height: "100%"
    },
    gridList: {
        listStyle: "none"
    },
    paper: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        background: theme.palette.common.white,
    },
    dense: {
        marginTop: "0",
    },
    formControl: {
        width: "100%",
    },
    avatar: {
        borderRadius: 0,
        width: "100%",
        height: "172px",
        backgroundColor: theme.palette.background.default,
        backgroundImage: `url(${Background})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        color: "transparent",
        border: 1,
        borderStyle: "solid",
        borderColor: theme.palette.background.lightbg,
        maxWidth: "178px",
        minWidth: "178px",
    },
    iconHover: {
        color: theme.palette.grey[500],
        verticalAlign: "middle"
    },
    gutterBottom: {
        marginBottom: theme.spacing(2),
    },
    control: {
        marginTop: theme.spacing(1),
    },
    update: {
        marginTop: theme.spacing(1),
    },
    button: {
        marginRight: '8px',
        minWidth: 120,
        height: 42,
    },
    profileImage: {
        width: "100%",
        height: "100%",
        objectFit: " cover",
        imageOrientation: 'from-image',
        color: "transparent",
    },
    input: {
        display: 'none',
    },
    //titleBar: {
    // background: "transparent",
    //},
    backanim: {
        transition: "400ms ease",
        '&:hover': {
            marginLeft: "-5px",
        },
    },
    icon: {
        fontSize: 26,
        verticalAlign: "middle",
        marginTop: "-3px",
        transition: "400ms ease",
        marginLeft: "-5px"
        /*'&:hover': {
        marginLeft: "-5px",
        },*/
    },
    marginy: {
        marginTop: theme.spacing(1) * 1,
        marginBottom: theme.spacing(1) * 1,
    },
    checkbox: {
        paddingRight: 5,
    },
    marginNegative: {
        marginTop: -1,
    },
    labelManufacturerClass: {
        fontWeight: 600
    },
    formLabelFocused: {},
    formLabelRoot: {
        '&$formLabelFocused': { color: "rgba(0, 0, 0, 0.54)" }  // To avoid MuiFormLabel focus color material-ui issue
    },
    ulBottomSeparator: {
        borderBottom: "1px solid #ececec"
    },
    formGroupControl: {
        margin : "10px auto 0"
    }

};
class EditDistributorStaff extends React.Component {
    constructor() {
        super();
        this.handlePermissionChange = this.handlePermissionChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.onProfilePhotoChange = this.onProfilePhotoChange.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
        this.Auth = new AuthService();
        this.state = {
            isloading: false,
            isimageloading: false,
            showPassword: false,
            previewImage: '',
            user: {

                FirstName: '', LastName: '', Email: '',
                Mobile: '', ProfilePhoto: '', Permissions: []
            }
        };

    }
    UNSAFE_componentWillMount() {

        const staffState = this.props.location.state.staff;
        const manufacturerList = this.props.location.state.manufacturerList;
        this.setState({
            user: {
                FirstName: staffState.firstName, LastName: staffState.lastName, Email: staffState.email, Mobile: staffState.phoneNumber,
                ProfilePhoto: staffState.profilePhoto, Permissions: staffState.permissions, UserId: staffState.userId, StaffId: staffState.staffId, Designation: staffState.designation,
                ManufacturerMapping: staffState.manufacturerMapping
            },
            ManufacturerList: manufacturerList
        });

    }
    componentDidMount() {
    }

    removeJustDisplayedAndUnattachedManufacturers = () => {
        const manufacturerMapping = this.state.user.ManufacturerMapping.filter(mapping => {
            return !(mapping.isManufacturerAttached === false && mapping.onlyDisplayedNotMapped === true);
        });

        const user = Object.assign({}, this.state.user); // Didn't alter actual state to be re-used
        user.ManufacturerMapping = manufacturerMapping;
        return user; //remove displayName
    }

    handleSubmit() {

        const userWithFinalMapping = this.removeJustDisplayedAndUnattachedManufacturers();
        this.setState({ isloading: true });
        const token = this.Auth.getToken();
        fetch(EditDistributorStaffApi, {
            method: 'POST',
            headers: {
                'authorization': `Bearer ${token}`, 'Accept': 'application/json', 'Content-Type': 'application/json'
            },
            body: JSON.stringify(userWithFinalMapping)
        }).then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res);

        }).then(() => {

            this.setState({ isloading: false });
        })
            .catch(() => {
                //this.setState({ isLoading: false, isLoginFailed: true });

            });
    };
    handleChange(e) {
        this.updateformState({ [e.target.name]: e.target.value });

    }
    updateformState(obj, extra) {
        const { user } = this.state;
        let userState =
            { ...user, ...obj };
        if (extra != null) {

            this.setState(() => ({ "user": userState, ...extra }));
        }
        else {
            this.setState(() => ({ "user": userState }));
        }


    }

    handlePermissionChange(e) {
        const targetPermissionName = e.target.name;
        const manufacturerId =parseInt(e.target.attributes.manufacturerid.value);
        let permissions = this.state.user.ManufacturerMapping.find(m => m.manufacturerId === manufacturerId).permissions;
        var elem = permissions.find((el) => { return el.name === targetPermissionName });
        elem.checked = e.target.checked;
        let latestFormStateCopy = Object.assign({}, this.state);
        this.setState(latestFormStateCopy);

    }

    handleManufacturerMapping(e) {
        const targetManufacturerId = parseInt(e.target.value);
        this.state.user.ManufacturerMapping.find(m => m.manufacturerId === targetManufacturerId).isManufacturerAttached = e.target.checked;
        let latestFormStateCopy = Object.assign({}, this.state);
        this.setState(latestFormStateCopy);
    }


    handleImageChange(event) {

        this.setState({
            previewImage: URL.createObjectURL(event.target.files[0])
        })
        this.onProfilePhotoChange(event);
    }
    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };
    onProfilePhotoChange = e => {
        const files = Array.from(e.target.files)
        this.setState({ isimageloading: true })

        const formData = new FormData()

        files.forEach((file) => {
            formData.append("File", file);
        })
        formData.append("UserId", this.state.user.UserId);
        const token = this.Auth.getToken();
        fetch(`${ProfilePhotoStaffApi}`, {
            method: 'POST',
            headers: {
                'authorization': `Bearer ${token}`
            },
            body: formData
        })
            .then(res => res.json())
            .then(images => {
                UserProfile.setProfilePhoto(images.fileName);
                this.updateformState({ ProfilePhoto: images.fileName }, { isimageloading: false });
            });
    }

    fetchUnAttachedManufacturersForStaffUser = (manufacturerMapping, manufacturerList) =>
        manufacturerList.filter(listItem => { return manufacturerMapping.find(mmap => mmap.manufacturerId === listItem.manufacturerId) ? false : true; });

    render() {

        const { classes } = this.props;

        const { FirstName, LastName, Mobile, ProfilePhoto, Designation, ManufacturerMapping } = this.state.user;
        const { ManufacturerList } = this.state;
        const { isloading, isimageloading } = this.state;

        const profileUrl = ProfilePath + ProfilePhoto;

        const unAttachedManufacturers = this.fetchUnAttachedManufacturersForStaffUser(ManufacturerMapping, ManufacturerList);

        // Add unattached Manufacturer details & fresh permissions in Staff models to render; onlyDisplayedNotMapped means didn't receive mapping from DB, so no need to POST for deletion if "isManufacturerAttached: false"
        unAttachedManufacturers.forEach((umItem) => {
            const clonedPermissions = JSON.parse(JSON.stringify(FreshPermissions));
            const mappingData = { manufacturerId: umItem.manufacturerId, displayName: umItem.displayName, permissions: clonedPermissions, isManufacturerAttached: false, onlyDisplayedNotMapped: true };
            ManufacturerMapping.push(mappingData);
        });

        const StaffManufacturersAndPermissions = ManufacturerMapping.map(mmap => {

            const permissionView = mmap.permissions.map(p => {
                return (<FormControlLabel
                    control={
                        <Checkbox name={p.name}
                            checked={Boolean(p.checked)}
                            onChange={(e) => this.handlePermissionChange(e)}
                            value={p.id}
                            inputProps={{ 'manufacturerid': mmap.manufacturerId }}
                            color="primary"
                            className={classes.checkbox}
                        />
                    }
                    label={p.name}
                    //classes={{ root: classes.labelClass }}
                />)
            });


            const manufacturerAssignmentView = (
                <ul>
                    <li>
                        <FormControlLabel
                            control={
                                <Checkbox name={"AttachedManufacturers-" + mmap.manufacturerId}
                                    checked={Boolean(mmap.isManufacturerAttached)}
                                    onChange={(e) => this.handleManufacturerMapping(e)}
                                    value={mmap.manufacturerId}
                                    color="primary"
                                    className={classes.checkbox}
                                    inputProps={{ 'manufacturerid': mmap.manufacturerId }}
                                />
                            }
                            label={mmap.displayName}
                            classes={{ label: classes.labelManufacturerClass }}
                        />
                    </li>
                </ul>
            );


            return (<ul className={classes.ulBottomSeparator}>
                <li>{manufacturerAssignmentView}</li>
                <li>{permissionView}</li>
            </ul>)
        });

        const image = isimageloading ? <CircularProgress color={theme.palette.common.white} size={19} style={styles.root} /> : (profileUrl != null && profileUrl !== '') ? (< img alt="profilepic" src={profileUrl} className={classes.profileImage} />) : (<PermIdentity></PermIdentity>);
        return (
            <div className={classes.root}>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>SPV | Edit Staff</title>
                </Helmet>
                <Grid container direction="row"
                    justify="space-between"
                    alignItems="center"
                    className={classes.marginy}>
                    <Grid item>
                        <Link to="/Staff" title="back to staff" >
                            <Typography color='primary' variant="h4">
                                <span className={classes.backanim}><Icon className={classes.icon} >keyboard_arrow_left</Icon>Back to Staff</span>
                            </Typography>
                        </Link>
                    </Grid>
                </Grid>
                <Grid container direction="row"
                    justify="space-between"
                    alignItems="center">
                    <Grid item>
                        <Typography variant="h1" >
                            {EditStaffHeaderTitle}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container direction="row" justify="space-between" alignItems="center" className={classes.control}>
                    <Grid item lg={5} md={7} sm={12}>
                        <ValidatorForm ref="form" instantValidate={true} autoComplete="off" onError={errors => console.log(errors)}
                            onSubmit={this.handleSubmit}>
                            <Paper elevation={0} className={classes.paper}>
                                <Grid container spacing={2}>
                                    <Grid item sm={12} xs={12} className={classes.gutterBottom}>
                                        <div className={classes.root}>
                                            <GridListTile className={classes.gridList}>
                                                <Avatar className={classes.avatar}>{image}
                                                    <GridListTileBar
                                                        title={<span className={classes.title}>Update</span>}
                                                        className={classes.titleBar}
                                                        actionIcon={<Fragment>
                                                            <input hidden accept="image/*" className={classes.input} ref={(file) => this.filefield = file} id="profile" type="file" onChange={(e) => this.handleImageChange(e)} />
                                                            <label htmlFor="profile">
                                                                <IconButton component="span" color="secondary">
                                                                    <Icon style={{ fontSize: 24 }}>
                                                                        camera_alt
                                                                 </Icon>
                                                                </IconButton>
                                                            </label>
                                                        </Fragment>
                                                        }
                                                    />
                                                </Avatar>
                                            </GridListTile>
                                        </div>
                                    </Grid>
                                    {/* <Hidden smDown>
                                        <Grid item lg={6} className={classes.gutterBottom}></Grid>
                                        </Hidden> */}
                                    <Grid item sm={6} xs={12}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <TextValidator autoComplete="off" onChange={(e) => this.handleChange(e)}
                                                name="FirstName"
                                                label="* First Name"
                                                placeholder="First Name"
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                value={FirstName}
                                                className={classNames(classes.dense)}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <TextValidator autoComplete="off" onChange={(e) => this.handleChange(e)}
                                                name="LastName"
                                                label="* Last Name"
                                                placeholder="Last Name"
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                value={LastName}
                                                className={classNames(classes.dense)}
                                                validators={['required']}
                                                errorMessages={['This field is required']}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <TextValidator onChange={(e) => this.handleChange(e)}
                                                name="Mobile"
                                                label="Phone"
                                                placeholder="Phone"
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                value={Mobile}
                                                className={classNames(classes.dense)}
                                                validators={['matchRegexp:^0(4|6)[0-9]{8}$', 'required']}
                                                errorMessages={['Mobile should be 10 digit and must start from 04 or 06', 'This field is required']}

                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={6} xs={12}>
                                        <FormControl className={classes.formControl} error>
                                            <TextValidator
                                                id="Designation" name="Designation"
                                                label="Designation"
                                                placeholder="Designation"

                                                fullWidth={true}
                                                margin="normal"
                                                variant="outlined"
                                                className={classNames(classes.dense)}
                                                value={Designation}
                                                onChange={this.handleChange}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={12} xs={12} className={classes.control}>
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <FormLabel component="legend"
                                                classes={{ root: classes.formLabelRoot, focused: classes.formLabelFocused }}>*  Attach Manufacturers & Permissions</FormLabel>
                                            <FormGroup row className={classes.formGroupControl}>
                                                {StaffManufacturersAndPermissions}
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>

                                </Grid>
                            </Paper>
                            <Grid container direction="row" className={classes.update} >
                                <Grid item={true} className={classes.marginNegative}>
                                    <Button variant="contained" size="large" color="#efefef" className={classes.button} type="button" onClick={this.props.history.goBack} >
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item={true}>
                                    <Button className={classes.button} size="large" variant="contained" type="submit" alignitem='center' color="primary" {...isloading === true ? 'disabled' : ''} tabIndex="3">
                                        {isloading ?
                                            <CircularProgress color={theme.palette.common.white} size={19} variant="indeterminate"
                                                thickness={4} /> :
                                            <span>Update</span>
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Grid>

                </Grid>

            </div>
        );
    }
}
export default withStyles(styles)(EditDistributorStaff);

